import { Wordmark } from './Wordmark';
import styles from './publicBand.module.css';

/**
 * The brand band every page outside the shell opens on (decision 0690): the
 * wordmark centred on the navy the shell's own header uses, over a gold rule.
 *
 * 🔒 The wordmark is one file, drawn light for a dark ground, so it is drawn on
 * that ground wherever it appears. 💰 The share link's landing page drew it on
 * the page's own light background, where it all but vanished, and the
 * certificate request page drew no mark at all (found while building,
 * 2026-09-24). The Login Screen's band was the one that was right, and this is
 * it, shared.
 */
export function PublicBand() {
  return (
    <header className={styles.band} data-public-band="true">
      <Wordmark />
    </header>
  );
}
